export const addFonts = (html, chunks) => {
    if (chunks.fonts && chunks.fonts.length) {
        for (let font of chunks.fonts) {
            if (font.url) {
                // append
                html = html.replace(`<body>`, `<body><link href="${font.url}" rel="stylesheet" type="text/css">`);
            }
        }
    }
    return html;
};
